import { useEffect, useRef } from 'react';

// Adds `is-visible` class when element enters viewport (works with .reveal css)
export default function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const items = el.querySelectorAll('.reveal');
    items.forEach((i) => io.observe(i));
    return () => io.disconnect();
  }, []);
  return ref;
}
